import { ClassificationLabels } from "../../../models/classification.map";
import { patientDisplayName } from "./commandeListFormat";

export function foldSearchText(value) {
    return String(value ?? "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLocaleLowerCase("fr-FR");
}

export function searchTerms(query) {
    const trimmed = String(query ?? "").trim();
    if (!trimmed) return [];
    return [trimmed, ...trimmed.split(/\s+/)]
        .filter((term, index, terms) => term && terms.indexOf(term) === index)
        .sort((left, right) => right.length - left.length);
}

export function matchingTerm(value, query) {
    const foldedValue = foldSearchText(value);
    return searchTerms(query).find(term => foldedValue.includes(foldSearchText(term))) ?? null;
}

export function matchRange(value, query) {
    const text = String(value ?? "");
    const term = matchingTerm(text, query);
    if (!term) return null;

    let folded = "";
    const offsets = [];
    for (let offset = 0; offset < text.length;) {
        const character = String.fromCodePoint(text.codePointAt(offset));
        const normalized = foldSearchText(character);
        for (let index = 0; index < normalized.length; index++) offsets.push(offset);
        folded += normalized;
        offset += character.length;
    }
    const startInFolded = folded.indexOf(foldSearchText(term));
    const start = offsets[startInFolded];
    const lastOffset = offsets[startInFolded + foldSearchText(term).length - 1];
    const lastCharacter = String.fromCodePoint(text.codePointAt(lastOffset));
    return { start, end: lastOffset + lastCharacter.length };
}

function classificationLabel(code) {
    return ClassificationLabels[code] ?? code;
}

export function hiddenSearchMatches(commande, query, visibleSender) {
    if (!String(query ?? "").trim()) return [];
    const matches = [];
    const add = (type, value) => {
        if (!value || !matchingTerm(value, query)) return;
        if (!matches.some(match => match.type === type && match.value === value)) matches.push({ type, value });
    };

    const ehpadCode = commande.ehpad?.code;
    if (ehpadCode !== visibleSender) add("EHPAD", ehpadCode);
    (commande.patients ?? []).forEach(patient => {
        add("Patient", patientDisplayName(patient));
        add("Classification", classificationLabel(patient.classification));
        (patient.medicaments ?? patient.produits ?? []).forEach(product => {
            add("Produit", product.nom);
            add("Produit", product.codeCis);
            add("Produit", product.cip13);
            add("Classification", classificationLabel(product.classificationMedicament));
        });
    });
    return matches;
}
